import React, { use } from "react";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import useFetch from "../hooks/useFetch";
import SimpleBar from "simplebar-react";

import { validateForm } from "../js/validate-form";
import { changeInput } from "../js/change-input";

import { Autoplay, EffectCreative } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import popUpIcon from "../css/images/success-icon.svg";
import successBg from "../css/images/success-bg.svg";

export default function ModalForm({ show, onHide }) {
  const modalFetch = useFetch(`${window.$host}/api/modal?populate=*`);

  const modalNodeRef = useRef(null);
  const modalInputName = useRef(null);
  const modalInputCompany = useRef(null);
  const modalInputContact = useRef(null);
  const modalInputTask = useRef(null);
  const modalInputAgreement = useRef(null);
  const modalSuccesRef = useRef(null);
  const sliderRef = useRef(null);

  useEffect(() => {
    if (
      !modalNodeRef.current ||
      !modalInputName.current ||
      !modalInputCompany.current ||
      !modalInputContact.current ||
      !modalInputTask.current ||
      !modalInputAgreement.current
    )
      return;
    const body = document.querySelector("body");
    const mobileHeader = document.querySelector(".header-mobile");

    if (show) {
      modalNodeRef.current.classList.add("open");
      body?.classList.add("no-scroll");
      body?.classList.add("modal-open");
      if (mobileHeader?.classList.contains("open")) {
        mobileHeader.classList.remove("open");
      }
      mobileHeader?.classList.add("under");
    } else {
      modalNodeRef.current.classList.remove("open");
      modalInputName.current.value = "";
      modalInputName.current.classList.remove("error");
      modalInputCompany.current.value = "";
      modalInputCompany.current.classList.remove("error");
      modalInputContact.current.value = "";
      modalInputContact.current.classList.remove("error");
      modalInputTask.current.value = "";
      modalInputTask.current.classList.remove("error");
      modalInputAgreement.current.checked = false;
      modalInputAgreement.current.classList.remove("error");
      body?.classList.remove("modal-open");
      if (!body?.classList.contains("cases-modal-open")) {
        body?.classList.remove("no-scroll");
      }
      mobileHeader?.classList.remove("under");
    }
  }, [
    show,
    modalNodeRef,
    modalInputName,
    modalInputCompany,
    modalInputContact,
    modalInputTask,
    modalInputAgreement,
    modalSuccesRef,
  ]);

  if (modalFetch.loading) return;
  if (modalFetch.error) return;

  function postForm(e) {
    e.preventDefault();
    const isInputsValid = validateForm([
      modalInputName,
      modalInputCompany,
      modalInputContact,
      modalInputTask,
      modalInputAgreement,
    ]);

    if (!isInputsValid) return;

    const options = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        data: {
          Name: modalInputName.current.value,
          Company: modalInputCompany.current.value,
          Contact: modalInputContact.current.value,
          Task: modalInputTask.current.value,
          Agreement: modalInputAgreement.current.checked,
        },
      }),
    };

    fetch(window.$host + "/api/forms", options).then((response) => {
      if (response.ok) {
        sliderRef.current.swiper.slideTo(0);
        sliderRef.current.swiper.autoplay.start();
        setTimeout(() => {
          modalSuccesRef.current.classList.add("visible");
        }, 300);
      }
    });
  }

  function closeModalAfterSuccess() {
    onHide(false);
    setTimeout(() => {
      sliderRef.current.swiper.slideTo(1);
      sliderRef.current.swiper.autoplay.stop();
      modalSuccesRef.current.classList.remove("visible");
    }, 300);
  }

  return (
    <div className="modal" ref={modalNodeRef}>
      <div className="modal-success" ref={modalSuccesRef}>
        <div className="modal-success__bg">
          <img src={successBg} alt="#" />
        </div>
        <div className="modal-success__content">
          <div className="modal-success__text">
            <div className="modal-success__icon">
              <img src={popUpIcon} alt="#" />
            </div>
            <Swiper
              ref={sliderRef}
              className="modal-sucess__swiper"
              modules={[Autoplay, EffectCreative]}
              loop={false}
              direction={"vertical"}
              speed={300}
              slidesPerView={1}
              spaceBetween={0}
              allowTouchMove={false}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
                stopOnLastSlide: true,
              }}
              effect={"creative"}
              creativeEffect={{
                prev: {
                  translate: [0, "-100%", 0],
                  opacity: 0.3,
                },
                next: {
                  translate: [0, "100%", 0],
                },
              }}
              onSwiper={(swiper) => {
                swiper.slideTo(1);
                swiper.autoplay.stop();
              }}
              onReachEnd={() => {
                setTimeout(() => {
                  onHide(false);
                  setTimeout(() => {
                    modalSuccesRef.current.classList.remove("visible");
                  }, 300);
                }, 1200);
              }}
            >
              <SwiperSlide>
                <p className="title-3 text-white">Изучаем вашу задачу</p>
              </SwiperSlide>
              <SwiperSlide>
                <p className="title-3 text-white">Оцениваем сроки реализации</p>
              </SwiperSlide>
              <SwiperSlide>
                <p className="title-3 text-white">
                  Подбираем релевантные кейсы
                </p>
              </SwiperSlide>
              <SwiperSlide>
                <p className="title-3 text-white">Бронируем слоты</p>
              </SwiperSlide>
              <SwiperSlide>
                <p className="title-3 text-white">Подбираем стэк</p>
              </SwiperSlide>
              <SwiperSlide>
                <p className="title-3 text-white">Создаем файл в Figma</p>
              </SwiperSlide>
            </Swiper>

            <p className="title-3 modal-success__gray-text">
              Скоро вернемся с&nbsp;предложением
            </p>
          </div>
          <button className="tur-arrow" onClick={closeModalAfterSuccess}>
            <span className="tur-arrow__text">На главную</span>
            <span className="tur-arrow__arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="17"
                height="12"
                viewBox="0 0 17 12"
                fill="none"
              >
                <circle
                  cx="4"
                  cy="6"
                  r="1"
                  transform="rotate(90 4 6)"
                  fill="#101828"
                />
                <circle
                  cx="1"
                  cy="6"
                  r="1"
                  transform="rotate(90 1 6)"
                  fill="#101828"
                />
                <circle
                  cx="7"
                  cy="6"
                  r="1"
                  transform="rotate(90 7 6)"
                  fill="#101828"
                />
                <circle
                  cx="10"
                  cy="6"
                  r="1"
                  transform="rotate(90 10 6)"
                  fill="#101828"
                />
                <circle
                  cx="13"
                  cy="6"
                  r="1"
                  transform="rotate(90 13 6)"
                  fill="#101828"
                />
                <circle
                  cx="16"
                  cy="6"
                  r="1"
                  transform="rotate(90 16 6)"
                  fill="#101828"
                />
                <circle
                  cx="13"
                  cy="9"
                  r="1"
                  transform="rotate(90 13 9)"
                  fill="#101828"
                />
                <circle
                  cx="13"
                  cy="3"
                  r="1"
                  transform="rotate(90 13 3)"
                  fill="#101828"
                />
                <circle
                  cx="10"
                  cy="0.500001"
                  r="0.5"
                  transform="rotate(90 10 0.500001)"
                  fill="#101828"
                />
                <circle
                  cx="10"
                  cy="11.5"
                  r="0.5"
                  transform="rotate(90 10 11.5)"
                  fill="#101828"
                />
              </svg>
            </span>
          </button>
        </div>
      </div>
      <SimpleBar className="modal-scroll-box">
        <button
          className="modal__close"
          onClick={() => {
            onHide(false);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <circle
              cx="4"
              cy="4"
              r="1"
              transform="rotate(-90 4 4)"
              fill="white"
            />
            <circle
              cx="12"
              cy="4"
              r="1"
              transform="rotate(-90 12 4)"
              fill="white"
            />
            <circle
              cx="6"
              cy="6"
              r="1"
              transform="rotate(-90 6 6)"
              fill="white"
            />
            <circle
              cx="8"
              cy="8"
              r="1"
              transform="rotate(-90 8 8)"
              fill="white"
            />
            <circle
              cx="10"
              cy="6"
              r="1"
              transform="rotate(-90 10 6)"
              fill="white"
            />
            <circle
              cx="6"
              cy="10"
              r="1"
              transform="rotate(-90 6 10)"
              fill="white"
            />
            <circle
              cx="10"
              cy="10"
              r="1"
              transform="rotate(-90 10 10)"
              fill="white"
            />
            <circle
              cx="4"
              cy="12"
              r="1"
              transform="rotate(-90 4 12)"
              fill="white"
            />
            <circle
              cx="12"
              cy="12"
              r="1"
              transform="rotate(-90 12 12)"
              fill="white"
            />
            <circle
              cx="2.5"
              cy="2.5"
              r="0.5"
              transform="rotate(-90 2.5 2.5)"
              fill="white"
            />
            <circle
              cx="13.5"
              cy="2.5"
              r="0.5"
              transform="rotate(-90 13.5 2.5)"
              fill="white"
            />
            <circle
              cx="13.5"
              cy="13.5"
              r="0.5"
              transform="rotate(-90 13.5 13.5)"
              fill="white"
            />
            <circle
              cx="2.5"
              cy="13.5"
              r="0.5"
              transform="rotate(-90 2.5 13.5)"
              fill="white"
            />
          </svg>
        </button>
        <div className="modal-info">
          <div className="modal-info__img">
            <img
              src={window.$host + modalFetch.data.data.Photo.url}
              alt={modalFetch.data.data.Photo.alternativeText}
            />
          </div>
          <p className="text-white text-16 modal-info__descr">
            {modalFetch.data.data.Descr}
          </p>
          <a
            href={modalFetch.data.data.LinkPath}
            className="text-16 text-gray modal-info__link"
            target="_blank"
          >
            {modalFetch.data.data.LinkText}
          </a>
        </div>
        <div className="container">
          <div className="modal__wrapper">
            <div className="modal__null-box"></div>
            <div className="modal__box">
              <h3 className="text-white title-3 modal__title">
                {modalFetch.data.data.Title}{" "}
                <span className="text-tur">
                  {modalFetch.data.data.TitleColor}
                </span>
              </h3>
              <form className="modal-form" onSubmit={postForm}>
                <label className="field-label">
                  <input
                    type="text"
                    name="name"
                    placeholder="Ваше имя"
                    className="field-input"
                    ref={modalInputName}
                    onChange={changeInput}
                  />
                  <span className="field-error"></span>
                </label>
                <label className="field-label">
                  <input
                    type="text"
                    name="company"
                    placeholder="Компания"
                    className="field-input"
                    ref={modalInputCompany}
                    onChange={changeInput}
                  />
                  <span className="field-error"></span>
                </label>
                <label className="field-label">
                  <input
                    type="text"
                    name="contact"
                    placeholder="Телефон, почта или телеграм"
                    className="field-input"
                    ref={modalInputContact}
                    onChange={changeInput}
                  />
                  <span className="field-error"></span>
                </label>
                <label className="field-label">
                  <input
                    type="text"
                    name="task"
                    placeholder="Коротко о задаче"
                    className="field-input"
                    ref={modalInputTask}
                    onChange={changeInput}
                  />
                  <span className="field-error"></span>
                </label>
                <label className="field-checkbox">
                  <input
                    type="checkbox"
                    name="agreement"
                    className="field-checkbox__checkbox"
                    ref={modalInputAgreement}
                    onChange={changeInput}
                  />
                  <span>
                    <span className="field-checkbox__text">
                      Я&nbsp;ознакомлен(а) с{" "}
                      <Link
                        to="/personaldata"
                        target="_blank"
                        rel="noreferrer"
                        className="field-checkbox__link"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Политикой в&nbsp;отношении обработки персональных
                        данных
                      </Link>{" "}
                      и&nbsp;даю согласие на&nbsp;обработку моих персональных
                      данных
                    </span>
                  </span>
                </label>

                <button type="submit" className="tur-arrow">
                  <span className="tur-arrow__text">Отправить</span>
                  <span className="tur-arrow__arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="17"
                      height="12"
                      viewBox="0 0 17 12"
                      fill="none"
                    >
                      <circle
                        cx="4"
                        cy="6"
                        r="1"
                        transform="rotate(90 4 6)"
                        fill="#101828"
                      />
                      <circle
                        cx="1"
                        cy="6"
                        r="1"
                        transform="rotate(90 1 6)"
                        fill="#101828"
                      />
                      <circle
                        cx="7"
                        cy="6"
                        r="1"
                        transform="rotate(90 7 6)"
                        fill="#101828"
                      />
                      <circle
                        cx="10"
                        cy="6"
                        r="1"
                        transform="rotate(90 10 6)"
                        fill="#101828"
                      />
                      <circle
                        cx="13"
                        cy="6"
                        r="1"
                        transform="rotate(90 13 6)"
                        fill="#101828"
                      />
                      <circle
                        cx="16"
                        cy="6"
                        r="1"
                        transform="rotate(90 16 6)"
                        fill="#101828"
                      />
                      <circle
                        cx="13"
                        cy="9"
                        r="1"
                        transform="rotate(90 13 9)"
                        fill="#101828"
                      />
                      <circle
                        cx="13"
                        cy="3"
                        r="1"
                        transform="rotate(90 13 3)"
                        fill="#101828"
                      />
                      <circle
                        cx="10"
                        cy="0.500001"
                        r="0.5"
                        transform="rotate(90 10 0.500001)"
                        fill="#101828"
                      />
                      <circle
                        cx="10"
                        cy="11.5"
                        r="0.5"
                        transform="rotate(90 10 11.5)"
                        fill="#101828"
                      />
                    </svg>
                  </span>
                </button>
              </form>
            </div>
            <div className="modal-privacy">
              <Link
                to="/personaldata"
                target="_blank"
                rel="noreferrer"
                className="text-16 text-gray modal-privacy__link"
              >
                Политика конфиденциальности
              </Link>
              <a
                href="#"
                target="_blank"
                className="text-16 text-gray modal-privacy__link"
              >
                Согласие на обработку персональных данных
              </a>
            </div>
          </div>
        </div>
      </SimpleBar>
    </div>
  );
}
